exports.linkResolver = (doc) => {
  switch (doc.type) {
    case "blog":
      return `/blog-details/${doc.uid}`;

    case "portfolio":
      return `/portfolios-details/${doc.uid}`;

    case "press":
      return `/press-details/${doc.uid}`;

    default:
      if (!doc.uid) return "/";
      return doc.uid;
  }
};